import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-shipment-container',
  templateUrl: './shipment-container.component.html',
  styleUrls: ['./shipment-container.component.css']
})
export class ShipmentContainerComponent implements OnInit {
    shipmentContainerKeyno;

    public edit?: Edit;

    public selectListStockLocations: StockLocationItem[] = [];

    public itemsListContents: Item[] = [];

    public receiving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.shipmentContainerKeyno = this.stateService.getStateParams()['shipmentcontainer_keyno'];
    }

    private async loadEdit() {
        if (!!this.shipmentContainerKeyno) {
            this.edit = (await this.datatask.Post(774, { shipmentcontainer_keyno: this.shipmentContainerKeyno }))[0];
        }
    }

    private async loadStockLocations() {
        if (!this.edit) return;

        return this.selectListStockLocations = await this.datatask.Post(1029, {
            stockzoneclass_keyno: '1',
            stockplace_id: this.edit.stockplace_id_to,
            add_all: '0'
        });
    }

    public async loadContents() {
        if (!this.edit) return;

        return this.itemsListContents = await this.datatask.Post(777, { shipmentcontainer_keyno: this.edit.shipmentcontainer_keyno });
    }

    public async receiveChanges() {
        if (!!this.edit) {
            try {
                this.receiving = true;

                const response = (await this.datatask.Post(775, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.receiving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadStockLocations();
        this.loadContents();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    shipmentcontainer_keyno: string;
    shipmentcontainer_name: string;
    shipmentcontainerstatus_keyno: string;
    shipmentcontainerstatus_name: string;
    show_shipmentcontainer_receive: string;
    stocklocation_keyno: string;
    stockplace_id_to: string;
}

interface StockLocationItem {
    stocklocation_keyno: string;
    stocklocation_name: string;
}
